import _ from 'lodash';
import validate from 'validate.js';
import { formatNumberString } from 'helpers/StringHelper';

const checkValue = value => value && String(value).length > 0;

export const validateEmail = emailAddress => {
  return !validate.single(emailAddress, { presence: true, email: true });
};

export const validatePhone = phoneNumber => {
  return !validate(
    { duration: phoneNumber },
    {
      duration: {
        numericality: true
      }
    }
  );
};

export const validatePocEmail = (pocEmail, emailList) => {
  return _.isUndefined(_.findKey(emailList, { email: pocEmail }));
};

export const pocFormValidate = ({
  pocFirstName,
  pocLastName,
  pocEmail,
  pocPhone,
  pocs
}) => {
  return (
    pocFirstName.length > 0 &&
    pocLastName.length > 0 &&
    pocEmail.length > 0 &&
    String(pocPhone).length > 0 &&
    validateEmail(pocEmail) &&
    validatePhone(pocPhone) &&
    validatePocEmail(pocEmail, pocs)
  );
};

export const validateBillingPoc = ({
  billingPocFirstName,
  billingPocLastName,
  billingPocEmail,
  billingPocPhone,
  ...rest
}) => {
  return (
    checkValue(billingPocFirstName) &&
    checkValue(billingPocLastName) &&
    checkValue(billingPocEmail) &&
    checkValue(billingPocPhone) &&
    validateEmail(billingPocEmail) &&
    validatePhone(billingPocPhone) &&
    makeEmaiBillinglValidation({ billingPocEmail, ...rest }).state === null
  );
};

export const isCountryValid = (country, state) => {
  // if country not selected
  if (Number(country) === 0) return false;

  // for US `state` is mandatory
  if (country === 'US') return checkValue(state);

  return checkValue(country);
};

export const validateBillingAddress = ({
  billingAddressName,
  billingAddressLine1,
  billingAddressCountry,
  billingAddressState,
  billingAddressZip,
  billingAddressCity
}) => {
  return (
    makeZipValidation(billingAddressZip, billingAddressCountry).state ===
      null &&
    checkValue(billingAddressName) &&
    checkValue(billingAddressLine1) &&
    checkValue(billingAddressCity) &&
    checkValue(billingAddressZip) &&
    isCountryValid(billingAddressCountry, billingAddressState)
  );
};

export const makeEmailValidation = ({ pocEmail, pocs, pocId }) => {
  const valid = { state: null, message: '' };

  if (pocEmail.length === 0) {
    return valid;
  }

  if (!validateEmail(pocEmail)) {
    return {
      state: 'error',
      message: 'Please enter a valid company email address'
    };
  }

  if (!validatePocEmail(pocEmail, pocs) && pocId === '') {
    return {
      state: 'error',
      message: 'This email has already used by another person'
    };
  }

  return valid;
};

export const makeEmaiBillinglValidation = ({
  billingPocEmail,
  pocs,
  billingPocId
}) => {
  const valid = { state: null, message: '' };

  if (!billingPocEmail || billingPocEmail.length === 0) {
    return valid;
  }

  if (!validateEmail(billingPocEmail)) {
    return {
      state: 'error',
      message: 'Please enter a valid company email address'
    };
  }

  if (!validatePocEmail(billingPocEmail, pocs) && billingPocId === '') {
    return {
      state: 'error',
      message: 'This email has already used by another person'
    };
  }

  return valid;
};

export const makePhoneValidation = ({ pocPhone }) => {
  const valid = { state: null, message: '' };

  if (pocPhone.length === 0) {
    return valid;
  }

  if (!validatePhone(pocPhone)) {
    return {
      state: 'error',
      message: 'Phone number should have ONLY digits'
    };
  }

  return valid;
};

export const makeBillingPhoneValidation = ({ billingPocPhone }) => {
  const valid = { state: null, message: '' };

  if (!billingPocPhone || billingPocPhone.length === 0) {
    return valid;
  }

  if (!validatePhone(billingPocPhone)) {
    return {
      state: 'error',
      message: 'Phone number should have ONLY digits'
    };
  }

  return valid;
};

export const makeZipValidation = (zipCode, countryCode) => {
  const valid = { state: null, message: '' };

  if (countryCode !== 'US') return valid;

  if (!zipCode || zipCode.length === 0) {
    return valid;
  }

  // regexp zipCode and keep numbers only
  const zipLength = formatNumberString(zipCode).length;

  if ((zipLength > 5 && zipLength < 9) || (zipLength > 0 && zipLength < 5)) {
    return {
      state: 'error',
      message: 'Invalid zipcode. Must be of 5- or 9-digit format ZIP codes'
    };
  }

  return valid;
};



// WEBPACK FOOTER //
// ./src/helpers/ValidatorHelper.js